import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { App } from "./App";
import { isElectronRuntime } from "./lib/runtime";
import "./styles.css";

// 데스크탑은 같은 렌더러를 쓰되 창 안의 제품 셸만 더 조밀한 데스크탑 테마를 쓴다.
// preload 권한을 열지 않고 Electron이 기본 User-Agent에 넣는 토큰으로만 구분한다.
if (isElectronRuntime()) {
  document.documentElement.classList.add("electron-shell");
}

const container = document.getElementById("root");
if (!container) throw new Error("#root 엘리먼트를 찾을 수 없습니다.");

// 데이터 라우터를 써야 실행 중인 AI 작업이 있을 때 브라우저 뒤로 가기까지
// useBlocker로 가로채 기존 커스텀 모달에서 확인할 수 있다.
const router = createBrowserRouter([{ path: "*", element: <App /> }]);

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
